export const quickFilesRouteTemplate = `/**
 * Vibeship DevTools - Files API Route
 * Endpoint: /api/vibeship/files
 */

import { NextRequest, NextResponse } from 'next/server';
import { glob } from 'glob';
import { statSync } from 'fs';
import { join } from 'path';

interface FileInfo {
  path: string;
  name: string;
  size: number;
  lastModified: string;
}

export async function GET(request: NextRequest) {
  try {
    const url = new URL(request.url);
    const pattern = url.searchParams.get('pattern') || '**/*.{md,mdx}';
    
    const files = await listFiles(pattern);
    return NextResponse.json({ files });
  } catch (error) {
    console.error('Files API Error:', error);
    return NextResponse.json(
      { 
        error: 'Failed to list files',
        message: error instanceof Error ? error.message : 'Unknown error'
      },
      { status: 500 }
    );
  }
}

async function listFiles(pattern: string): Promise<FileInfo[]> {
  const cwd = process.cwd();
  
  try {
    const files = glob.sync(pattern, {
      cwd,
      ignore: ['**/node_modules/**', '**/.next/**', '**/dist/**', '**/.git/**'],
      absolute: false,
    });
    
    return files.map(file => {
      const fullPath = join(cwd, file);
      const stat = statSync(fullPath);
      
      return {
        path: file,
        name: file.split('/').pop() || file,
        size: stat.size,
        lastModified: stat.mtime.toISOString(),
      };
    });
  } catch (error) {
    console.error('Error listing files:', error);
    return [];
  }
}
`;